



















import { defineComponent, PropType, ref } from "@vue/composition-api";
export default defineComponent({
  props: {
    items: {
      type: Array as PropType<any[]>,
      default: (): any[] => []
    },
    toText: {
      type: Function as PropType<CallableFunction>,
      default: (i: any) => i
    }
  },
  setup(props: { items: any[]; text: string[] }, { emit }) {
    const dragTarget = ref(-1);

    return {
      dragTarget,
      sort(index: number) {
        if (dragTarget.value < 0) return;
        if (dragTarget.value === index) return;
        const swapSmall = dragTarget.value < index ? dragTarget.value : index;
        const swapLarge = swapSmall === index ? dragTarget.value : index;
        emit("update", [
          ...props.items.slice(0, swapSmall),
          props.items[swapLarge],
          ...props.items.slice(swapSmall + 1, swapLarge),
          props.items[swapSmall],
          ...props.items.slice(swapLarge + 1)
        ]);
      }
    };
  }
});
